import React, { Component } from "react";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/styles";

import Typography from "@material-ui/core/Typography";
import PersonalInformation from "../../molecules/PersonalInformation/index";
import OrdersUser from "../../molecules/OrdersUser/index";
//import AdminDocumentViewer from "../AdminDocumentViewer/index";

const styles = theme => ({
  root: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  aff: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  }
});

class AdminUserViewer extends Component {
  renderAffiliate() {
    const { User } = this.props;
    const baseURL = process.env.REACT_APP_BASEURL_API;
    const AffLink = baseURL + "/p/a/" + User.AffiliateLinks[0];

    return (
      <div className={this.props.classes.aff}>
        <Typography>
          <b>Affiliate URL: </b> {AffLink}
        </Typography>
        {User.ReferedBy.affiliate && (
          <Typography>
            <b>Refered by: </b>
            {User.ReferedBy.affiliate.id}{" "}
            {User.ReferedBy.RefereeEmail !== ""
              ? " (" + User.ReferedBy.RefereeEmail + ")"
              : ""}
          </Typography>
        )}
      </div>
    );
  }
  render() {
    const { classes, User } = this.props;

    if (User) {
      return (
        <div className={classes.root}>
          <Typography variant="h5" style={{ marginTop: "1em" }}>
            <b>Status:</b> {User.Status}
          </Typography>
          <PersonalInformation {...User} />
          {this.renderAffiliate()}
          {/* <AdminDocumentViewer />
          <div>{User.Email}</div>
          <div>{User.UserID}</div> */}
          <OrdersUser User={User} Orders={User.Orders} />
        </div>
      );
    } else return null;
  }
}

const mapStateToProps = state => ({
  User: state.admin.User
});

const mapDispatchToProps = dispatch => {
  return {
    // adminSearchUser: searchtext => dispatch(adminSearchUser(searchtext))
  };
};

const AdminUserViewerRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminUserViewer);
export default withStyles(styles)(AdminUserViewerRedux);
